import { extend, configure } from 'vee-validate';
import { required, email, confirmed, min } from 'vee-validate/dist/rules';
import { stripPhoneMask } from "./helpers/stripPhoneMask";
import moment from 'moment';

configure({
    classes: {
        valid: 'is-valid',
        invalid: 'is-invalid',
        dirty: ['is-dirty']
    }
})

extend('required', {
    ...required,
    message: 'This field is required.',
});

extend('email', {
    ...email,
    message: 'Invalid email.'
});

extend('phone', {
    validate: number => {
        // Remove mask from input
        const formattedNumber = stripPhoneMask(number);
        return formattedNumber.match(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/);
    },
    message: 'Invalid phone number.'
});

extend('confirmed', {
    ...confirmed,
    message: 'The passwords you entered do not match'
});

extend('min', {
    ...min,
    message: 'The {_field_} must be at least {length} characters long.'
});

extend('minmax', {
    validate(value, {min, max}) {
        return value.length >= min && value.length <= max;
    },
    params: ['min', 'max'],
    message: 'The {_field_} field must have between {min} and {max} characters.'
});

extend('password', {
    validate: password => {
        const strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!\(\)+@#\$%\^&\*])(?=.{8,})");
        return strongRegex.test(password);
    },
    message: 'A password must contain at least one: uppercase letter, lowercase letter, number, and special character (e.g. !, *, & etc).'
});

extend('time', {
    validate: time => {
        return time.match(/^(1[0-2]|0?[1-9]):([0-5]?[0-9])( ?[AP]M)?$/)
    },
    message: 'Invalid time format'
})

extend('timeBefore', {
    params: ['target'],
    validate(value, { target }) {
        if(!target) return true;
        return moment(value, ['h:m a', 'H:m']).isBefore(moment(target, ['h:m a', 'H:m']));
    },
    message: 'Start time must be before end time'
});

extend('requiredIf', {
    params: ['target'],
    validate(value, { target }) {
        if(value !== null && target === null) {
            return false;
        } else {
            return true;
        }
    },
    message: '{_field_} requires a {target}'
})